// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 99,
  argument: "All are invited to rejoice in God, the Creator of all.",
  verses: [
    { n: 1, text: "A psalm of praise." },
    { n: 2, text: "Sing joyfully to God, all the earth: serve ye the Lord with gladness. Come in before his presence with exceedingly great joy." },
    { n: 3, text: "Know ye that the Lord, he is God: he made us, and not we ourselves. We are his people and the sheep of his pasture." },
    { n: 4, text: "Go ye into his gates with praise, into his courts with hymns: and give glory to him. Praise ye his name: 5 for the Lord is sweet, his mercy endureth for ever, and his truth to generation and generation." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Praise. Theodoret reads, \"A psalm of David for confession, without a title in Hebrew.\" But now that text and the Septuagint agree with us. The psalm refers to the same events as the preceding.", attribution: "Calmet" }
    ] },
    { verse: 2, notes: [
      { text: "Earth. Both Jews and Gentiles, (Worthington) converted to the faith of Christ. (Haydock) — Gladness. God loves a cheerful giver. [2 Corinthians ix. 7.] (Menochius) — He hears our prayers in all places. Yet appoints the temple more peculiarly for that duty.", attribution: "Worthington" }
    ] },
    { verse: 3, notes: [
      { text: "Not. St. Jerome seems to have read lu for lo, and translates, \"and we are his,\" which Houbigant follows. But the Vulgate gives a very necessary instruction, as some might perhaps forget that God preserves their life every instant, (Berthier) and some have foolishly imagined, that the collection of things might give existence, or be eternal.", attribution: "Berthier" }
    ] },
    { verse: 5, notes: [
      { text: "Truth. This is commonly joined with mercy. (Calmet) — God faithfully executes what he has promised (Worthington) for the liberation of his people, and the conversion of the Gentiles.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
